(function() {
  const videos = document.querySelectorAll<HTMLVideoElement>('.js-scroll-video');
  if (!videos.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target as HTMLVideoElement;
      if (entry.isIntersecting) {
        // Lazy-load src from data-src on first intersection
        const dataSrc = video.dataset.src;
        if (dataSrc && !video.src) {
          video.src = dataSrc;
          video.load();
        }
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.3 });

  videos.forEach((video) => observer.observe(video));
})();
